import { ContentCard } from '../../../components/ContentCard/ContentCard';
import './BonusBox.css';
import { Icon, spinner } from '../../../components/Icon/Icon';
import { useFormatting } from '../../../i18n/i18n';

export const BonusBox = ({
	icon,
	heading,
	bonusValue,
}: {
	icon: JSX.Element;
	heading: string;
	bonusValue: number | undefined;
}): JSX.Element => {
	const { asPrice } = useFormatting();
	if (typeof bonusValue === 'undefined') {
		return (
			<ContentCard className="bonus-box">
				<h2>{heading}</h2>
				<Icon shape={spinner} />
			</ContentCard>
		);
	}
	return (
		<ContentCard className="bonus-box">
			<h2>{heading}</h2>
			<p className="bonus-value">{asPrice(bonusValue)}</p>
			{icon}
		</ContentCard>
	);
};
